'use strict';

const $ = require('jquery');

$(function () {
    const $lookup_container = $('.school-lookup');
    const $lookup_school = $lookup_container.find('.school-lookup__lookup input');
    const $lookup_error = $lookup_container.find('.error');
    const $schoolJsonUrl = window.location.origin + window.school_json_url;

    $lookup_container.each(function () {
        const $lookup_trigger = $lookup_container.find('.school-lookup__trigger');
        const $lookup_address = $lookup_container.find('.school-lookup__schools');

        // Do the school lookup
        $lookup_trigger.click(function (e) {
            e.preventDefault();
            const $this = $(this);
            $lookup_error.hide();

            // Get the search query
            const searched_school = $lookup_school.val();

            $this.prop('disabled', true);

            // Populate the school cards
            if (searched_school) {
                $.getJSON($schoolJsonUrl, {search: searched_school})
                    .done(function (data) {
                        $lookup_address.empty();

                        for (const school of Object.values(data.results)) {
                            $lookup_address.append(`<div class="school-lookup__result" data-name='${school.name}' data-address='${school.formatted_address}' data-address-line-1='${school.address_line_1}' data-address-line-2='${school.address_line_2}' data-city='${school.city}' data-postcode='${school.postcode}' data-lat='${school.latitude}' data-lng='${school.longitude}' data-region='${school.region}' data-locale='${school.locale}' data-country-code='${school.country_code}' data-google-id='${school.place_id}'><h4>${school.name}</h4><p>${school.formatted_address} <br>${school.region}</p></div>`);
                        }

                        $this.prop('disabled', false);
                        $lookup_error.hide();
                    })
                    .fail(function (jqXHR, textStatus) {
                        alert('Sorry, we could not find your school. Please try a different search query.');
                        $this.prop('disabled', false);
                        console.log('Request failed: ' + textStatus);
                    });
            } else {
                alert('Please enter a valid school name or address.');
            }
        });

        // Populate hidden fields on school card click
        const $schoolName = $('input[name="school_name"]');
        const $schoolAddress = $('input[name="school_address"]');
        const $schoolAddressLine1 = $('input[name="school_address_line_1"]');
        const $schoolAddressLine2 = $('input[name="school_address_line_2"]');
        const $schoolCity = $('input[name="school_city"]');
        const $schoolPostcode = $('input[name="school_postcode"]');
        const $schoolRegion = $('input[name="school_region"]');
        const $schoolLocale = $('input[name="school_locale"]');
        const $schoolCountryCode = $('input[name="school_country_code"]');
        const $schoolLat = $('input[name="school_lat"]');
        const $schoolLng = $('input[name="school_lng"]');
        const $schoolGoogleId = $('input[name="school_google_id"]');

        $lookup_address.on('click', '.school-lookup__result', function() {
            $('.school-lookup__result').removeClass('selected');

            const $this = $(this);
            $this.addClass('selected');

            $schoolName.val($this.data('name'));
            $schoolAddress.val($this.data('address'));
            $schoolAddressLine1.val($this.data('address-line-1'));
            $schoolAddressLine2.val($this.data('address-line-2'));
            $schoolCity.val($this.data('city'));
            $schoolPostcode.val($this.data('postcode'));
            $schoolRegion.val($this.data('region'));
            $schoolLocale.val($this.data('locale'));
            $schoolCountryCode.val($this.data('country-code'));
            $schoolLat.val($this.data('lat'));
            $schoolLng.val($this.data('lng'));
            $schoolGoogleId.val($this.data('google-id'));

            $('.find-school-fields').addClass('hide');
            $('.find-school-form__chosen-school').removeClass('hide');
            $('.find-school-form__chosen-school .school').html('');
            $('.find-school-form__chosen-school .school').append(`<h5>${$this.data('name')}</h5><p>${$this.data('address')}</p>`);

            // Reveal next fieldset
            $('.find-school-form .about-fields').removeClass('hide');
            $('.find-school-form .reveal-detail-fields').removeClass('hide');
        });
    });


    const $findSchoolForm = $('.find-school-form');

    if ($findSchoolForm.length) {
        // Edit school button
        $('.find-school-form__chosen-school .edit').on('click', function() {
            $('.find-school-form__chosen-school').addClass('hide');
            $('.find-school-fields').removeClass('hide');
        });

        let $revealDetailFields = $findSchoolForm.find('.reveal-detail-fields'),
            $classInfoFields = $findSchoolForm.find('.about-fields__class-info'),
            $classNameField = $findSchoolForm.find('input[name="class_name"]'),
            $registrationTypeField = $findSchoolForm.find('input[name="registration_type"]');

        // Field reveals
        $revealDetailFields.on('click', function() {
            $(this).remove(); // Removes to stop re-appear on edit school
            $findSchoolForm.find('.detail-fields').removeClass('hide');
            $findSchoolForm.find('.form-card__actions').removeClass('hide');
        });

        $registrationTypeField.on('change', function() {
            $classInfoFields.removeClass('hide');
            $classNameField.val('');
            $classNameField.closest('.field').toggleClass('hide', $(this).val() !== 'class');
        });

        // Reveal fields if there are any errors, re-populate chosen school
        if ($('.errorlist').length) {
            $('.find-school-fields').addClass('hide');
            $findSchoolForm.find('.find-school-form__chosen-school, .about-fields, .detail-fields, .form-card__actions, .about-fields__class-info').removeClass('hide');
            $('.find-school-form__chosen-school .school').append(`<h5>${$('input[name="school_name"]').val()}</h5><p>${$('input[name="school_address"]').val()}</p>`);
            $revealDetailFields.remove(); // Removes to stop re-appear on edit school
            $classNameField.closest('.field').toggleClass('hide', $findSchoolForm.find('input[name="registration_type"]:checked').val() !== 'class');
        }

        // Show school lookup fields if theres an error in that fieldset
        if ($('.find-school-fields .errorlist').length >= 2) {
            $('.find-school-form__chosen-school').addClass('hide');
            $('.find-school-fields').removeClass('hide');
        }
    }
});
